import api from "../../config/api";
import { firebase } from "../../config/firebase";
export const FETCH_SCHEDULE = "FETCH_SCHEDULE";
export const FETCH_SCHEDULE_SUCCESS = "FETCH_SCHEDULE_SUCCESS";
export const FETCH_SCHEDULE_FAILURE = "FETCH_SCHEDULE_FAILURE";
export const CLEAR_SCHEDULE = "CLEAR_SCHEDULE";

export const fetchSchedule = (id) => ({
  type: FETCH_SCHEDULE,
  id,
});

export const fetchScheduleSuccess = (data) => ({
  type: FETCH_SCHEDULE_SUCCESS,
  data,
});

export const fetchScheduleFailure = () => ({
  type: FETCH_SCHEDULE_FAILURE,
});

export const clearSchedule = () => ({
  type: CLEAR_SCHEDULE,
});

export const getSchedule = (id) => {
  return (dispatch) => {
    dispatch(fetchSchedule());
    return firebase.reloadAuth().then((res) => {
      try {
        const token = res.ya === null ? res.za : res.ya;

        api
          .get("/schedules/schedule/", { id: id }, token)
          .then((res) => {
            dispatch(fetchScheduleSuccess(res));
            return res;
          })
          .catch((err) => dispatch(fetchScheduleFailure(err)));
      } catch (err) {
        console.log(err);
      }
    });
  };
};
